export const SAMPLE_TOKEN = {
  VALUE_1: 'value-1',
  VALUE_2: 'value-2',
};
